import React, { useState, useEffect } from 'react';
import styles from './Box.module.css';
import FlipNumbers from 'react-flip-numbers';

const Box = (props) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const {title, value, change, description, empty, noBackground, providerCount, flippable} = props.tile;
  let numberStyle;
  let displayValue = value;
  let topProviders;
  
  if (value > 0 && providerCount?.length > 0) {
    topProviders = providerCount
      .sort((a, b) => b.count - a.count)
      .slice(0, 3);
  }

  if (!value || noBackground) {}
  else if (value < 15000) numberStyle = styles.good
  else if (value < 30000) numberStyle = styles.slow
  else numberStyle = styles.error

  if (displayValue < 1000) {}
  else if (displayValue < 1000000) displayValue = (displayValue / 1000).toFixed(1) + 'K';
  else if (displayValue > 1000000) displayValue = (displayValue / 1000000).toFixed(1) + 'M';

  return (
    <div className={`${styles.tile} ${flippable ? isFlipped ? styles.flipped : styles.providerTile : ''}`}
      onMouseEnter={() => flippable && setIsFlipped(true)}
      onMouseLeave={() => flippable && setIsFlipped(false)}
    >
      <div className={styles.front}>
        {!empty && (
          <>
            <div className={styles.tileHeader}>
              <h3>{title}</h3>
            </div>
            <div className={`${styles.flipNumbers} ${numberStyle}`}>
              {/* <p className={styles.tileValue}>{value || 0}</p> */}
              {/* <p className={styles.tileValue}>{Math.floor(Math.random() * 10) || 0}</p> */}
              <FlipNumbers duration={1} nonNumberStyle={{fontSize: 30}} height={20} width={25} play perspective={150} numbers={`${displayValue || 0}`} />
              {/* <p className={styles.tileChange}>{change}</p> */}
              {/* <p className={styles.tileDescription}>{description}</p> */}
            </div>
          </>
        )}
      </div>
      <div className={styles.back}>
        <div className={styles.tileHeader}>
          <h3>{title}</h3>
        </div>
        {topProviders ? topProviders.map((data, index) => (
          <div key={index} className={styles.providers}>
            <h4>{data.providerName}</h4>
            <div className={numberStyle}>
              <FlipNumbers nonNumberStyle={{ fontSize: 18 }} height={18} width={18} play perspective={150} numbers={`${data.count || 0}`} />
            </div>
          </div>
        ))
          :
          <div className={numberStyle}>
            <FlipNumbers nonNumberStyle={{ fontSize: 18 }} height={18} width={18} play perspective={150} numbers={`${displayValue || 0}`} />
          </div>
        }
      </div>
    </div>
  );
};

export default Box;
